export default __webpack_public_path__ + "static/media/pic1.843a6cd4.jpg";